import { register } from '../../api/register';
import { BrowserFourdApi } from '.';

export class Register implements register.Api {
  constructor(private fourd: BrowserFourdApi) {}

  reloadDocumentRegisterList(request: register.ReloadDocumentRegisterListRequest): void {
    this.fourd.call4Dv2('register.reloadDocumentRegisterList', request);
  }
  reloadPowerEstateList(request: register.ReloadPowerEstateListRequest): void {
    this.fourd.call4Dv2('register.reloadPowerEstateList', request);
  }
}
